// extracted by mini-css-extract-plugin
module.exports = {"closeLink":"closeLink__3Nip7"};